// Built once and reused: Intl.NumberFormat is expensive to instantiate, and
// formatCurrency is called per-row inside *ngFor on every change-detection cycle.
const currencyFormatter = new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
});

export const formatCurrency = (value: number): string =>
    currencyFormatter.format(value);

/** Se muestra cuando el monto falta o no es un número. */
export const MISSING_AMOUNT_PLACEHOLDER = '—';

export type AmountInput = number | string | null | undefined;

/**
 * Formatea un monto que puede llegar como string desde la API (misma regla que
 * el pipe `arsCurrency`): lo que no es un número finito se muestra como `—`.
 */
export const formatAmount = (value: AmountInput): string => {
    const amount = toAmount(value);
    return amount === null ? MISSING_AMOUNT_PLACEHOLDER : formatCurrency(amount);
};

/** Convierte la entrada en un número finito, o null si no representa un monto. */
function toAmount(value: AmountInput): number | null {
    if (value === null || value === undefined) return null;
    // Number('   ') es 0: un string en blanco no es un monto.
    if (typeof value === 'string' && value.trim() === '') return null;
    const amount = typeof value === 'number' ? value : Number(value);
    return Number.isFinite(amount) ? amount : null;
}
